const cacheKeyFromParams = (params) => {
    if (typeof params === 'string') {
        return params;
    }
    return JSON.stringify(params);
};
const cache = new Map();
const cacheTimeout = 1000 * 60 * 5; // 5 minutes
const setCacheTimeout = (key, timeout = cacheTimeout) => {
    // clear previous timeout
    const timer = setTimeout(() => {
        cache.delete(key);
    }, timeout);
    return timer;
};
export function getCachedResult(params) {
    const key = cacheKeyFromParams(params);
    const cachedResult = cache.get(key);
    if (cachedResult) {
        try {
            return JSON.parse(cachedResult.value);
        }
        catch (e) {
            clearTimeout(cachedResult.timer);
            cache.delete(key);
        }
    }
    return null;
}
export function addToCache(params, payload, timeoutInMinutes = cacheTimeout) {
    const key = cacheKeyFromParams(params);
    const cachedResult = cache.get(key);
    if (cachedResult) {
        clearTimeout(cachedResult.timer);
    }
    const timer = setCacheTimeout(key, timeoutInMinutes * 1000 * 60);
    cache.set(key, {
        timer,
        value: JSON.stringify(payload),
    });
    return payload;
}
export function removeFromCache(params) {
    const key = cacheKeyFromParams(params);
    cache.delete(key);
}
